module.exports = __webpack_public_path__ + "static/img/我的医生-B@3x.ab64270.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index/bottom/我的医生-B@3x.png
// module id = 1252
// module chunks = 382